const organizers = [
  {
    short: 'НЭСПРИМ',
    full: 'Национальный экспертный совет по развитию инновационной медицины',
    url: 'https://нэсприм.рф',
    logo: '/img/organizer-nesprim.png',
  },
  {
    short: 'СЗОИБ',
    full: 'Северо-западное общество по изучению боли',
    url: 'https://painmed.ru',
    logo: '/img/organizer-painmed.png',
  },
];

export default function OrganizersSection() {
  return (
    <section id="organizers" className="py-20 md:py-24 bg-[#f5f2ed]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#c8963e] mb-4">
            Организаторы
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0f3d32]">
            Кто организует
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row gap-6 justify-center mb-14">
          {organizers.map((org) => (
            <a
              key={org.short}
              href={org.url}
              target="_blank"
              rel="nofollow noreferrer"
              className="flex-1 max-w-sm bg-white rounded-2xl p-8 flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-200 cursor-pointer"
            >
              <div className="w-32 h-20 flex items-center justify-center mb-5">
                <img src={org.logo} alt={org.short} className="max-w-full max-h-full object-contain" />
              </div>
              <p className="text-gray-500 text-sm leading-relaxed">{org.full}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
